import refund_change_policy_get from './2.0.0/index'
export default refund_change_policy_get